import { ref } from 'vue'
import { usePlayer } from '@/composables/game/player'
import { env } from '@/env'

export const showHiddenFeatures = ref(!env.app.isProd)
// export const showHiddenFeatures = ref(!env.app.isProd && window.location.hostname !== 'localhost')

export const showPocPage = ref(false)

export enum FEATURE_FLAG {}

export const useBooleanFeatureFlag = (feature: FEATURE_FLAG) => {
  const { player } = usePlayer()
  return player.value.featureFlags[feature] ?? false
}
